import React, { Component } from 'react'
import StandaloneSearchBox from "react-google-maps/lib/components/places/StandaloneSearchBox";
import {connect} from "react-redux"
import {pickPos, dropPos, clearPickup, clearDrop} from "../../actions"

const google = window.google;

const geocoder = new google.maps.Geocoder();

class AddressInput extends Component { 

    componentWillMount() {
        const refs = {};
        this.setState({
            pos: {},
            onSearchBoxMounted: ref => {
                refs.searchBox = ref;
            },
            onPlacesChanged: () => {
                const places = refs.searchBox.getPlaces();
                if(places.length > 0){
                    let address = places[0].formatted_address;
                    let lat = places[0].geometry.location.lat();
                    let lng = places[0].geometry.location.lng();
                    let pos = {lat, lng};
                    this.sendLoc(pos, address);
                }
            },
        })
    }

    sendLoc(pos, address){
        let {type, pickPos, dropPos} = this.props;
        if(type === "P"){
            pickPos(pos, false, address);
        } else{
            dropPos(pos, false, address);
        }
    }

    reverseGeoCode(latlng){
        geocodeLatLng(geocoder, latlng).then(data => {
            this.input.value = data;
            this.sendLoc(latlng, data);
        });
    }

    componentWillReceiveProps(nextProps){
        let { type, drag } = nextProps;
        if(drag){
            if(nextProps[drag] !== this.props[drag] && drag === type){
                this.reverseGeoCode(nextProps[drag]);
            }
        }
    }

    handleChange = () => {
        let {type, clearDrop, clearPickup} = this.props;
        if(this.props[type]){
            if(type === "P"){
                clearPickup();
            } else {
                clearDrop();
            }
        }
    }
    
    render() {
        let {err, type} = this.props;
        let pos = this.props[type];
        let isInvalid = err && !pos;
        let className = `form-control input-md ${isInvalid ? 'iperr': ''}`.trim();
        return (
            <div className="col-md-6">
                <StandaloneSearchBox 
                    ref={this.state.onSearchBoxMounted}
                    onPlacesChanged={this.state.onPlacesChanged}
                >
                    <>
                        <input 
                            ref={input => this.input = input}
                            name="name" 
                            placeholder="Street address *" 
                            className={className} 
                            type="text" 
                            onChange={this.handleChange}
                            autoComplete="false"
                        />
                        {isInvalid ? <div className="errtxt">Invalid Address</div> : null}
                    </>
                </StandaloneSearchBox>
            </div>
        )
    }
}

function geocodeLatLng(geocoder, latlng) {
    return new Promise(function(resolve, reject) {
        geocoder.geocode({'location': latlng}, function(results, status) {
            if (status === 'OK') {
                if(results[0]){
                    resolve(results[0].formatted_address);
                }
            } else {
                reject({error: true});
            }
        })
    })
} 

const mapStateToProps = ({bookingLoc}) => ({
    P: bookingLoc.pickup,
    D: bookingLoc.drop,
    P_address: bookingLoc.pickupAddress,
    D_address: bookingLoc.dropAddress,
    drag: bookingLoc.drag
})

const mapDispatchToProps = {pickPos, dropPos, clearPickup, clearDrop};

export default connect(mapStateToProps, mapDispatchToProps)(AddressInput)